export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5129.138f38c0.jpg";